"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cSettingId = void 0;
exports.cSettingId = Object.freeze({
    userListManagementColumns: 'userListManagementColumns',
    exportsUserTable: 'exportsUserTable',
    users: 'users',
    structureOrders: 'structure.orders',
    structureDefaults: 'structure.defaults',
    serviceNameVariations: 'serviceNameVariations',
    keyAliases: 'keyAliases',
    themeMode: 'themeMode',
    videoChat: 'videoChat',
    searchRules: 'searchRules',
    videoChatSearch: 'video-chat-search',
    mentionSearch: 'mention-search',
    chatSearch: 'chat-search',
    userConnectivity: 'userConnectivity'
});
